export const AVAILABLE_CHAIN_ID = ["rebel-2"]

// Add required properties for Cosmes SDK compatibility
type NetworkConfig = {
  URL?: string
  chainID: string
  gasAdjustment?: number
  name: string
  lcd: string
  rpc: string
  // Additional properties used in the app
  id?: string
  contract?: string
  swap?: string
  mantle?: string
  factory?: string
  service?: string
  serviceV1?: string
  dashboard?: string
  router?: string
  fee?: {
    gasPrice: string
    amount: string
    gas: string
  }
}

type NetworkInfo = NetworkConfig

const networks: Record<string, NetworkInfo> = {
  "rebel-2": {
    name: "classic",
    chainID: "rebel-2",
    lcd: "https://rebel-lcd.luncgoblins.com",
    id: "rebel-2",
    contract: "/tequila.json",
    swap: "/swap.json",
    mantle: "https://fcd.terra.dev/",
    fee: { gasPrice: "0.00506", amount: "1518", gas: "2000000" }, // 0.000500 UST
    factory: "terra1rsppu0xtfv0zjhmzs86akt8j7kjtv6u75753zl8wy3qcc8qaasusx6vjdh",
    service:
      process.env.REACT_APP_MAINNET_SERVICE_URL ||
      "https://api-classic.terraswap.io/v2",
    serviceV1:
      process.env.REACT_APP_MAINNET_SERVICE_V1_URL ||
      "https://api-classic.terraswap.io/v1",
    dashboard:
      process.env.REACT_APP_MAINNET_DASHBOARD_URL ||
      "https://api-classic.terraswap.io/v2/dashboard",
    router: "terra1cvt5ehhtk0th8f3dlfd3xhjy2j8t2q5twpd96y0ftg6qjneh4egqj0343q",
    // Add required properties for Cosmes SDK compatibility
    URL: "https://rebel-lcd.luncgoblins.com",
    rpc: "https://rebel-rpc.luncgoblins.com",
    gasAdjustment: 1.4,
  },
}

export default networks
